import React from 'react';
import { X, AlertTriangle, BookOpen, Mail, Layers, Clock } from 'lucide-react';
interface AdminDetailPanelProps {
  detailPanel: {
    type: string;
    data: any;
    title?: string;
  } | null;
  setDetailPanel: (panel: any) => void;
}
export function AdminDetailPanel({
  detailPanel,
  setDetailPanel
}: AdminDetailPanelProps) {
  if (!detailPanel) return null;
  return <div className="fixed inset-0 z-50 flex justify-end bg-slate-900/20 backdrop-blur-sm" onClick={e => {
    if (e.target === e.currentTarget) setDetailPanel(null);
  }} data-id="element-3528">
      <div className="w-full max-w-lg bg-white shadow-2xl flex flex-col h-full" data-id="element-3529">
        <div className="h-12 border-b border-slate-100 flex items-center justify-between px-5 bg-slate-50/50" data-id="element-3530">
          <h3 className="text-sm font-bold text-slate-900" data-id="element-3531">
            {detailPanel.title || 'Детали'}
          </h3>
          <button className="p-1.5 text-slate-400 hover:text-slate-600 rounded-md hover:bg-slate-100" onClick={() => setDetailPanel(null)} data-id="element-3532">
            <X className="w-4 h-4" data-id="element-3533" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5" data-id="element-3534">
          {/* User Detail */}
          {detailPanel.type === 'user' && detailPanel.data && <div className="space-y-4" data-id="element-3535">
              <div className="flex items-center gap-3" data-id="element-3536">
                <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-lg" data-id="element-3537">
                  {(detailPanel.data.name || '').split(' ').map((n: string) => n[0]).join('')}
                </div>
                <div data-id="element-3538">
                  <h3 className="font-bold text-slate-900" data-id="element-3539">
                    {detailPanel.data.name}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3540">
                    {detailPanel.data.email}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3541">
                {[['ID', detailPanel.data.id], ['Статус', detailPanel.data.status], ['Регистрация', detailPanel.data.date], ['Последний вход', detailPanel.data.lastLogin], ['Баланс', `${(detailPanel.data.balance || 0).toLocaleString('ru-RU')} ₽`], ['Заказов', detailPanel.data.orders], ['Потрачено', detailPanel.data.spent], ['Подписка', detailPanel.data.subscription || 'Нет'], ['Страна', detailPanel.data.country], ['Телефон', detailPanel.data.phone]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3542">
                    <span className="text-xs text-slate-500" data-id="element-3543">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3544">
                      {value}
                    </span>
                  </div>)}
              </div>
              {detailPanel.data.notes && <div className="bg-amber-50 rounded-lg p-3" data-id="element-3545">
                  <div className="text-xs font-bold text-amber-800 mb-1" data-id="element-3546">
                    Заметки
                  </div>
                  <div className="text-xs text-amber-700" data-id="element-3547">
                    {detailPanel.data.notes}
                  </div>
                </div>}
            </div>}

          {/* Order Detail */}
          {detailPanel.type === 'order' && detailPanel.data && <div className="space-y-4" data-id="element-3548">
              <div className="bg-slate-50 rounded-lg p-4" data-id="element-3549">
                <div className="text-sm font-bold text-slate-900 mb-1" data-id="element-3550">
                  Заказ {detailPanel.data.id}
                </div>
                <div className="text-xs text-slate-500" data-id="element-3551">
                  от {detailPanel.data.date}
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3552">
                {[['Клиент', detailPanel.data.client], ['Услуга', detailPanel.data.service], ['Астролог', detailPanel.data.astrologer], ['Сумма', detailPanel.data.amount], ['Статус', detailPanel.data.status], ['Оплата', detailPanel.data.payment]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3553">
                    <span className="text-xs text-slate-500" data-id="element-3554">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3555">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Astrologer Detail */}
          {detailPanel.type === 'astrologer' && detailPanel.data && <div className="space-y-4" data-id="element-3556">
              <div className="flex items-center gap-3" data-id="element-3557">
                <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 font-bold text-lg" data-id="element-3558">
                  {(detailPanel.data.name || '').split(' ').map((n: string) => n[0]).join('')}
                </div>
                <div data-id="element-3559">
                  <h3 className="font-bold text-slate-900" data-id="element-3560">
                    {detailPanel.data.name}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3561">
                    {detailPanel.data.spec}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3562">
                {[['ID', detailPanel.data.id], ['Email', detailPanel.data.email], ['Рейтинг', `⭐ ${detailPanel.data.rating}`], ['Отзывов', detailPanel.data.reviews], ['Заказов', detailPanel.data.orders], ['Заработано', detailPanel.data.earnings], ['Статус', detailPanel.data.status], ['Верификация', detailPanel.data.verified ? 'Да' : 'Нет']].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3563">
                    <span className="text-xs text-slate-500" data-id="element-3564">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3565">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Ad Placement Detail */}
          {detailPanel.type === 'ad-placement' && detailPanel.data && <div className="space-y-4" data-id="element-3566">
              <div className="flex items-center gap-3" data-id="element-3567">
                <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 font-bold text-lg" data-id="element-3568">
                  {detailPanel.data.type === 'Баннер' ? '🖼️' : '📝'}
                </div>
                <div data-id="element-3569">
                  <h3 className="font-bold text-slate-900" data-id="element-3570">
                    {detailPanel.data.object}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3571">
                    {detailPanel.data.id}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3" data-id="element-3572">
                <div className="bg-slate-50 rounded-lg p-3" data-id="element-3573">
                  <span className="text-[10px] text-slate-500 block" data-id="element-3574">
                    Статус
                  </span>
                  <span className={`text-sm font-bold ${detailPanel.data.status === 'active' ? 'text-emerald-600' : 'text-slate-700'}`} data-id="element-3575">
                    {detailPanel.data.status === 'active' ? 'Активно' : detailPanel.data.status === 'paused' ? 'На паузе' : detailPanel.data.status === 'completed' ? 'Завершено' : detailPanel.data.status === 'queued' ? 'В очереди' : detailPanel.data.status === 'scheduled' ? 'Запланировано' : detailPanel.data.status}
                  </span>
                </div>
                <div className="bg-slate-50 rounded-lg p-3" data-id="element-3576">
                  <span className="text-[10px] text-slate-500 block" data-id="element-3577">
                    Оплата
                  </span>
                  <span className={`text-sm font-bold ${detailPanel.data.payment === 'paid' ? 'text-emerald-600' : 'text-amber-600'}`} data-id="element-3578">
                    {detailPanel.data.payment === 'paid' ? 'Оплачено' : 'Ожидает'}
                  </span>
                </div>
              </div>

              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3579">
                {[['Рекламодатель', detailPanel.data.advertiser], ['Слот', detailPanel.data.slotName], ['Тип', detailPanel.data.type], ['Период', `${detailPanel.data.periodStart} — ${detailPanel.data.periodEnd}`], ['Стоимость', `${(detailPanel.data.price || 0).toLocaleString('ru-RU')} ₽`], ['Приоритет', `${detailPanel.data.priority}/10`], ['Автопродление', detailPanel.data.autoRenew ? 'Включено' : 'Выключено'], ['Таймер', detailPanel.data.timer]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3580">
                    <span className="text-xs text-slate-500" data-id="element-3581">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3582">
                      {value}
                    </span>
                  </div>)}
              </div>

              {detailPanel.data.impressionsPlan > 0 && <div data-id="element-3583">
                  <div className="flex justify-between text-xs mb-1.5" data-id="element-3584">
                    <span className="font-medium text-slate-700" data-id="element-3585">Показы</span>
                    <span className="text-slate-500" data-id="element-3586">
                      {(detailPanel.data.impressionsFact || 0).toLocaleString('ru-RU')}{' '}
                      /{' '}
                      {(detailPanel.data.impressionsPlan || 0).toLocaleString('ru-RU')}
                    </span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-3587">
                    <div className={`h-2 rounded-full transition-all ${detailPanel.data.impressionsFact / detailPanel.data.impressionsPlan >= 0.95 ? 'bg-rose-500' : detailPanel.data.impressionsFact / detailPanel.data.impressionsPlan >= 0.8 ? 'bg-amber-500' : 'bg-indigo-500'}`} style={{
                width: `${Math.min(100, detailPanel.data.impressionsFact / detailPanel.data.impressionsPlan * 100)}%`
              }} data-id="element-3588" />
                  </div>
                </div>}

              <div className="grid grid-cols-3 gap-3" data-id="element-3589">
                <div className="bg-blue-50 rounded-lg p-3 text-center" data-id="element-3590">
                  <div className="text-lg font-bold text-blue-700" data-id="element-3591">
                    {(detailPanel.data.impressionsFact || 0).toLocaleString('ru-RU')}
                  </div>
                  <div className="text-[10px] text-blue-600 font-medium" data-id="element-3592">
                    Показы
                  </div>
                </div>
                <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-3593">
                  <div className="text-lg font-bold text-purple-700" data-id="element-3594">
                    {(detailPanel.data.clicks || 0).toLocaleString('ru-RU')}
                  </div>
                  <div className="text-[10px] text-purple-600 font-medium" data-id="element-3595">
                    Клики
                  </div>
                </div>
                <div className="bg-amber-50 rounded-lg p-3 text-center" data-id="element-3596">
                  <div className="text-lg font-bold text-amber-700" data-id="element-3597">
                    {detailPanel.data.ctr}
                  </div>
                  <div className="text-[10px] text-amber-600 font-medium" data-id="element-3598">
                    CTR
                  </div>
                </div>
              </div>

              {detailPanel.data.slotCapacity && <div className="bg-slate-50 rounded-lg p-3" data-id="element-3599">
                  <div className="text-xs font-bold text-slate-700 mb-2" data-id="element-3600">
                    Ёмкость слота
                  </div>
                  <div className="flex gap-4 text-xs" data-id="element-3601">
                    <span data-id="element-3602">
                      Лимит:{' '}
                      <strong data-id="element-3603">{detailPanel.data.slotCapacity.limit}</strong>
                    </span>
                    <span data-id="element-3604">
                      Активных:{' '}
                      <strong className="text-emerald-600" data-id="element-3605">
                        {detailPanel.data.slotCapacity.active}
                      </strong>
                    </span>
                    <span data-id="element-3606">
                      В очереди:{' '}
                      <strong className="text-blue-600" data-id="element-3607">
                        {detailPanel.data.slotCapacity.queued}
                      </strong>
                    </span>
                  </div>
                </div>}
            </div>}

          {/* Featured Astrologer Detail */}
          {detailPanel.type === 'featured-astrologer' && detailPanel.data && <div className="space-y-4" data-id="element-3608">
              <div className="flex items-center gap-3" data-id="element-3609">
                <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-lg" data-id="element-3610">
                  {(detailPanel.data.astrologer || '').split(' ').map((n: string) => n[0]).join('')}
                </div>
                <div data-id="element-3611">
                  <h3 className="font-bold text-slate-900" data-id="element-3612">
                    {detailPanel.data.astrologer}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3613">
                    Закреплённый астролог • {detailPanel.data.position}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3614">
                {[['Позиция', detailPanel.data.position], ['Период', detailPanel.data.period], ['Стоимость', `${(detailPanel.data.price || 0).toLocaleString('ru-RU')} ₽`], ['Показы', detailPanel.data.impressions], ['Клики', detailPanel.data.clicks], ['CTR', detailPanel.data.ctr], ['Бронирования', `${detailPanel.data.bookings}`], ['Статус', detailPanel.data.status === 'active' ? 'Активно' : detailPanel.data.status === 'scheduled' ? 'Запланировано' : detailPanel.data.status]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3615">
                    <span className="text-xs text-slate-500" data-id="element-3616">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3617">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Featured Course Detail */}
          {detailPanel.type === 'featured-course' && detailPanel.data && <div className="space-y-4" data-id="element-3618">
              <div className="flex items-center gap-3" data-id="element-3619">
                <div className="w-12 h-12 rounded-xl bg-purple-50 flex items-center justify-center text-purple-600" data-id="element-3620">
                  <BookOpen className="w-6 h-6" data-id="element-3621" />
                </div>
                <div data-id="element-3622">
                  <h3 className="font-bold text-slate-900" data-id="element-3623">
                    {detailPanel.data.course}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3624">
                    Закреплённый курс • {detailPanel.data.position}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3625">
                {[['Позиция', detailPanel.data.position], ['Период', detailPanel.data.period], ['Стоимость', `${(detailPanel.data.price || 0).toLocaleString('ru-RU')} ₽`], ['Показы', detailPanel.data.impressions], ['Клики', detailPanel.data.clicks], ['CTR', detailPanel.data.ctr], ['Покупки', `${detailPanel.data.purchases}`], ['Статус', detailPanel.data.status === 'active' ? 'Активно' : detailPanel.data.status === 'scheduled' ? 'Запланировано' : detailPanel.data.status]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3626">
                    <span className="text-xs text-slate-500" data-id="element-3627">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3628">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Email Campaign Detail */}
          {detailPanel.type === 'email-campaign' && detailPanel.data && <div className="space-y-4" data-id="element-3629">
              <div className="flex items-center gap-3" data-id="element-3630">
                <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600" data-id="element-3631">
                  <Mail className="w-6 h-6" data-id="element-3632" />
                </div>
                <div data-id="element-3633">
                  <h3 className="font-bold text-slate-900" data-id="element-3634">
                    {detailPanel.data.name}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3635">
                    {detailPanel.data.id} • Email-кампания
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3636">
                {[['Дата', detailPanel.data.date], ['Отправлено', detailPanel.data.sent], ['Open Rate', detailPanel.data.openRate], ['CTR', detailPanel.data.ctr], ['Конверсии', `${detailPanel.data.conversions}`], ['Доход', `${(detailPanel.data.revenue || 0).toLocaleString('ru-RU')} ₽`], ['Статус', detailPanel.data.status === 'sent' ? 'Отправлено' : 'Запланировано']].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3637">
                    <span className="text-xs text-slate-500" data-id="element-3638">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3639">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>}

          {/* Slot Detail */}
          {detailPanel.type === 'slot-detail' && detailPanel.data && <div className="space-y-4" data-id="element-3640">
              <div className="flex items-center gap-3" data-id="element-3641">
                <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600" data-id="element-3642">
                  <Layers className="w-6 h-6" data-id="element-3643" />
                </div>
                <div data-id="element-3644">
                  <h3 className="font-bold text-slate-900" data-id="element-3645">
                    {detailPanel.data.name}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3646">
                    {detailPanel.data.id} • {detailPanel.data.page}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3647">
                {[['Страница', detailPanel.data.page], ['Тип', detailPanel.data.type], ['Размер', detailPanel.data.size], ['Базовая цена', `${(detailPanel.data.basePrice || 0).toLocaleString('ru-RU')} ₽`], ['Лимит', `${detailPanel.data.limit}`], ['Активных', `${detailPanel.data.active}`], ['В очереди', `${detailPanel.data.queued}`], ['Ротация', detailPanel.data.rotation], ['Длительность', `${detailPanel.data.duration} дн.`], ['Fill Rate', `${detailPanel.data.fillRate}%`], ['Статус', detailPanel.data.status === 'active' ? 'Активен' : detailPanel.data.status === 'paused' ? 'На паузе' : detailPanel.data.status]].filter(([, v]) => v !== undefined && v !== null).map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3648">
                      <span className="text-xs text-slate-500" data-id="element-3649">{label}</span>
                      <span className="text-xs font-bold text-slate-900" data-id="element-3650">
                        {value}
                      </span>
                    </div>)}
              </div>
              {detailPanel.data.events && detailPanel.data.events.length > 0 && <div data-id="element-3651">
                    <div className="text-xs font-bold text-slate-700 mb-2" data-id="element-3652">
                      Последние события
                    </div>
                    <div className="space-y-2" data-id="element-3653">
                      {detailPanel.data.events.map((ev: any, i: number) => <div key={i} className="flex items-start gap-2 bg-slate-50 rounded-lg p-2.5" data-id="element-3654">
                          <div className="w-1.5 h-1.5 rounded-full bg-indigo-400 mt-1.5 shrink-0" data-id="element-3655" />
                          <div data-id="element-3656">
                            <div className="text-xs text-slate-700" data-id="element-3657">
                              {ev.description}
                            </div>
                            <div className="text-[10px] text-slate-400" data-id="element-3658">
                              {ev.time}
                            </div>
                          </div>
                        </div>)}
                    </div>
                  </div>}
            </div>}

          {/* Queue Item Detail */}
          {detailPanel.type === 'queue-item' && detailPanel.data && <div className="space-y-4" data-id="element-3659">
              <div className="flex items-center gap-3" data-id="element-3660">
                <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center text-amber-600" data-id="element-3661">
                  <Clock className="w-6 h-6" data-id="element-3662" />
                </div>
                <div data-id="element-3663">
                  <h3 className="font-bold text-slate-900" data-id="element-3664">
                    {detailPanel.data.object}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-3665">
                    {detailPanel.data.id} • Позиция #
                    {detailPanel.data.queuePosition}
                  </p>
                </div>
              </div>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-3666">
                {[['Рекламодатель', detailPanel.data.advertiser], ['Слот', detailPanel.data.slotName], ['Тип', detailPanel.data.type], ['Период', `${detailPanel.data.periodStart} — ${detailPanel.data.periodEnd}`], ['Стоимость', `${(detailPanel.data.price || 0).toLocaleString('ru-RU')} ₽`], ['Приоритет', `${detailPanel.data.priority}/10`], ['Тип очереди', detailPanel.data.queueType], ['Оплата', detailPanel.data.paymentStatus === 'paid' ? 'Оплачено' : 'Ожидает'], ['Слот освободится', detailPanel.data.slotFreeTimer || '—'], ['Fast Track', detailPanel.data.fastTrack ? 'Да' : 'Нет']].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-3667">
                    <span className="text-xs text-slate-500" data-id="element-3668">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-3669">
                      {value}
                    </span>
                  </div>)}
              </div>
              {detailPanel.data.conflict && <div className="bg-rose-50 border border-rose-200 rounded-lg p-3 flex items-start gap-2" data-id="element-3670">
                  <AlertTriangle className="w-4 h-4 text-rose-500 mt-0.5 shrink-0" data-id="element-3671" />
                  <div data-id="element-3672">
                    <div className="text-xs font-bold text-rose-700" data-id="element-3673">
                      Конфликт
                    </div>
                    <div className="text-xs text-rose-600" data-id="element-3674">
                      {detailPanel.data.conflictReason}
                    </div>
                  </div>
                </div>}
            </div>}
        </div>
      </div>
    </div>;
}